import React from 'react';

class TraceOrder extends React.Component {
  render() {
    return <div className='dms-body'>
      {this.props.children}
    </div>
  }
};
export default TraceOrder;


// WEBPACK FOOTER //
// ./src/routes/favorites/index.js